import { z } from 'zod'
import { ChainID } from '@lukso/controllerapps-sharedlogic-primitives'

import { InitialChainID } from '../../../cross-chain-deployment/InitialChainID'

export const InitialChainIDSchema = z.number()

type InitialChainIDReportText = z.infer<typeof InitialChainIDSchema>

export function mapDomainToReportText(
  initialChainID: InitialChainID
): InitialChainIDReportText {
  return initialChainID.toNumber()
}

export function mapReportTextToDomain(
  reportText: InitialChainIDReportText
): InitialChainID {
  return InitialChainID.create({
    initialChainIDValue: ChainID.create({
      chainIDValue: reportText,
    }),
  })
}
